import axios from "axios"
import toastr from "toastr"
import Cookies from "js-cookie"

class Notice {
    constructor() {
        this.init()
    }

    init () {
        this.cacheDOM()
        this.bindEvents()
        this.fetch_notice()
    }

    cacheDOM () {
        this.$bpa_notice = $( '.bpa-notice' )
    }

    bindEvents () {
    }

    async fetch_notice () {
        let blocked = new Set()

        const current_cookie_val = JSON.parse( Cookies.get( 'closed' ) ? Cookies.get( 'closed' ) : '[]' )

        current_cookie_val.forEach( element => {
            blocked.add( element )
        } )

        const res = await axios.get( window.ajaxurl, {
            params: { action: 'fetch_notice' }
        } )

        if ( true === res?.data?.success ) {
            const messages = res.data.data
            toastr.options = {
                maxOpened: 1,
                tapToDismiss: false,
                positionClass: "toast-bottom-right",
                timeOut: 0,
                hideDuration: 1,
                extendedTimeOut: 0,
                closeButton: true,
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut",
                closeHtml: `<button><img src='${ window.bpa_baseurl }/resources/images/icons/close-light.svg' width="17" height="17"></button>`,
            }

            messages.map( message => {
                if ( [ ...blocked ].includes( message.code ) ) { return }

                toastr.success( message.message, '', {
                    positionClass: `toast-bottom-right ${ message.code }`,
                    onCloseClick: function ( e ) {
                        blocked.add( message.code )
                        Cookies.set( 'closed', JSON.stringify( [ ...blocked ] ), { expires: 1 } )
                    }
                } )
            } )
        }
    }
}

new Notice()
